import { render, staticRenderFns } from "./BasePlanCard.vue?vue&type=template&id=6496a4eb&scoped=true&"
import script from "./BasePlanCard.vue?vue&type=script&lang=js&"
export * from "./BasePlanCard.vue?vue&type=script&lang=js&"
import style0 from "./BasePlanCard.vue?vue&type=style&index=0&id=6496a4eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6496a4eb",
  null
  
)

export default component.exports